export default function SimpleAbout() {
  return (
    <main className="about about--split">
      <section className="about__col">
        <div className="about__content">
          <p>
I'm a trained engineer and software developer, and a self-taught photographer and designer based in Frankfurt am Main.
            {"\n\n"}
Currently, I'm a mid-senior computer vision engineer at
{" "}
            <a href="https://telekinesis.ai/" target="_blank" rel="noopener noreferrer">
            Telekinesis
            </a>,
{" "}where I build computer vision algorithms for physical AI applications.
            {"\n\n"}
Browse my <a href="/projects" className="mail-link">projects</a> and <a href="/articles" className="mail-link">articles</a>.
            {"\n\n"}
I'm available for freelance prototyping, consulting, or tech advisory work.
{" "}Say hi — <a href="mailto:info@aarist.de" className="mail-link">email</a> me{" ;^)"}
          </p>
        </div>
      </section>

      <section className="about__col">
        <div className="about__content">
          <p>
Ich bin ausgebildeter Ingenieur und Softwareentwickler, sowie autodidaktischer Fotograf und Designer ansässig in Frankfurt am Main.
            {"\n\n"}
Derzeit bin ich als mid-senior Computer Vision Ingenieur bei
{" "}
            <a href="https://telekinesis.ai/" target="_blank" rel="noopener noreferrer">
            Telekinesis
            </a>
{" "}tätig, wo ich Computer-Vision-Algorithmen für Physical AI entwickle.
            {"\n\n"}
Einblicke in meine <a href="/projects" className="mail-link">Projekte</a> und <a href="/articles" className="mail-link">Artikel</a>.
            {"\n\n"}
Ich bin verfügbar für freiberufliche Prototypenentwicklung, Beratung oder als technischer Advisor.
{" "}Kontakt per <a href="mailto:info@aarist.de" className="mail-link">E-Mail</a>{" ;^)"}
          </p>
        </div>
      </section>
    </main>
  );
}
